import { Category, StyleTemplate, StyleTemplateListResponse } from '../types/template';

// 模拟分类数据
export const categories: Category[] = [
  { id: 'all', name: '全部' },
  { id: 'travel', name: '旅游打卡' },
  { id: 'ethnic', name: '民族服饰' },
  { id: 'workplace', name: '职场形象' },
  { id: 'wedding', name: '婚纱写真' },
  { id: 'casual', name: '日常生活' },
  { id: 'vintage', name: '复古风格' },
  { id: 'fantasy', name: '奇幻魔法' },
  { id: 'sports', name: '运动健身' },
  { id: 'fashion', name: '时尚潮流' },
];

// 模拟模版数据生成函数
const generateTemplates = (count: number, offset: number = 0): StyleTemplate[] => {
  const templates: StyleTemplate[] = [];
  const categoryIds = categories.slice(1).map(cat => cat.id); // 除去"全部"分类
  
  // AI人物风格化模版标题
  const templateTitles = [
    '浪漫樱花季', '复古港风', '欧式宫廷', '现代都市白领',
    '民族风情', '海边度假', '森系少女', '商务精英',
    '婚纱梦幻', '运动活力', '学院风', '街头潮流',
    '古风仕女', '未来科技', '田园清新', '摇滚朋克',
    '优雅名媛', '休闲咖啡', '户外冒险', '艺术文青',
    '温柔淑女', '酷帅机车', '甜美少女', '知性气质'
  ];
  
  for (let i = 0; i < count; i++) {
    const index = offset + i;
    const titleIndex = index % templateTitles.length;
    templates.push({
      id: `template-${index}`,
      name: templateTitles[titleIndex],
      imageUrl: `https://picsum.photos/300/400?random=${index}`,
      categoryId: categoryIds[index % categoryIds.length],
    });
  }
  
  return templates;
};

// 模拟API调用
export const fetchTemplates = (
  categoryId: string = 'all',
  page: number = 1,
  pageSize: number = 20
): Promise<StyleTemplateListResponse> => {
  return new Promise((resolve) => {
    setTimeout(() => {
      const offset = (page - 1) * pageSize;
      let allTemplates = generateTemplates(10); // 总共10个模版

      if (categoryId !== 'all') {
        allTemplates = allTemplates.filter(template => template.categoryId === categoryId);
      }
      
      const items = allTemplates.slice(offset, offset + pageSize);
      const hasMore = offset + pageSize < allTemplates.length;
      
      resolve({ items, hasMore });
    }, 500); // 模拟网络延迟
  });
};

// 根据ID获取单个模板
export const fetchTemplateById = (id: string): Promise<StyleTemplate | null> => {
  return new Promise((resolve) => {
    setTimeout(() => {
      const allTemplates = generateTemplates(100); // 生成所有模板
      const template = allTemplates.find(template => template.id === id);
      resolve(template || null);
    }, 300); // 模拟网络延迟
  });
};